"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetMDFactoryInterface = exports.calculateEEPROMChecksum = exports.DisplayMode = exports.MemoryOpenType = exports.MemoryType = void 0;
var utils_1 = require("../utils");
var netmd_shared_objects_1 = require("../netmd-shared-objects");
var query_utils_1 = require("../query-utils");
var jsbi_1 = __importDefault(require("jsbi"));
var MemoryType;
(function (MemoryType) {
    MemoryType[MemoryType["MAPPED"] = 0] = "MAPPED";
    MemoryType[MemoryType["EEPROM_2"] = 2] = "EEPROM_2";
    MemoryType[MemoryType["EEPROM_3"] = 3] = "EEPROM_3";
})(MemoryType = exports.MemoryType || (exports.MemoryType = {}));
var MemoryOpenType;
(function (MemoryOpenType) {
    MemoryOpenType[MemoryOpenType["CLOSE"] = 0] = "CLOSE";
    MemoryOpenType[MemoryOpenType["READ"] = 1] = "READ";
    MemoryOpenType[MemoryOpenType["WRITE"] = 2] = "WRITE";
    MemoryOpenType[MemoryOpenType["READ_WRITE"] = 3] = "READ_WRITE";
})(MemoryOpenType = exports.MemoryOpenType || (exports.MemoryOpenType = {}));
var DisplayMode;
(function (DisplayMode) {
    DisplayMode[DisplayMode["DEFAULT"] = 0] = "DEFAULT";
    DisplayMode[DisplayMode["OVERRIDE"] = 1] = "OVERRIDE";
})(DisplayMode = exports.DisplayMode || (exports.DisplayMode = {}));
function calculateChecksum(data, as16Bit) {
    var crc = 0;
    var newData = data;
    if (as16Bit) {
        newData = new Uint16Array(data.length / 2);
        for (var i = 0; i < newData.length; i++) {
            newData[i] = (data[2 * i + 1] << 8) | data[2 * i];
        }
    }
    var temp = newData.length;
    newData.forEach(function (e) {
        temp = (temp & 0xffff0000) | e;
        crc ^= temp;
        for (var i = 0; i < 16; i++) {
            var ts = crc & 0x8000;
            crc <<= 1;
            if (ts)
                crc ^= 0x1021;
        }
    });
    crc = (crc & 0xffff) >>> 0;
    return crc;
}
function calculateEEPROMChecksum(data) {
    return calculateChecksum(data, true);
}
exports.calculateEEPROMChecksum = calculateEEPROMChecksum;
var NetMDFactoryInterface = /** @class */ (function () {
    function NetMDFactoryInterface(netMd, logger) {
        this.netMd = netMd;
        this.logger = logger;
        this.logger = logger === null || logger === void 0 ? void 0 : logger.child({ class: 'NetMDFactoryInterface' });
    }
    NetMDFactoryInterface.prototype.sendQuery = function (query, test, acceptInterim) {
        if (test === void 0) { test = false; }
        if (acceptInterim === void 0) { acceptInterim = false; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sendCommand(query, test)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.readReply(acceptInterim)];
                }
            });
        });
    };
    NetMDFactoryInterface.prototype.sendCommand = function (query, test) {
        if (test === void 0) { test = false; }
        return __awaiter(this, void 0, void 0, function () {
            var statusByte;
            return __generator(this, function (_a) {
                if (test) {
                    statusByte = new Uint8Array([netmd_shared_objects_1.Status.specificInquiry]).buffer;
                }
                else {
                    statusByte = new Uint8Array([netmd_shared_objects_1.Status.control]).buffer;
                }
                this.netMd.sendFactoryCommand(utils_1.concatArrayBuffers(statusByte, query));
                return [2 /*return*/];
            });
        });
    };
    NetMDFactoryInterface.prototype.readReply = function (acceptInterim) {
        if (acceptInterim === void 0) { acceptInterim = false; }
        return __awaiter(this, void 0, void 0, function () {
            var currentAttempt, data, status;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        currentAttempt = 0;
                        _a.label = 1;
                    case 1:
                        if (!(currentAttempt < NetMDFactoryInterface.maxInterimReadAttempts)) return [3 /*break*/, 8];
                        return [4 /*yield*/, this.netMd.readFactoryReply()];
                    case 2:
                        (data = (_a.sent()).data);
                        if (data === undefined) {
                            throw new Error('unexpected undefined value in readReply');
                        }
                        status = data.getUint8(0);
                        if (!(status === netmd_shared_objects_1.Status.notImplemented)) return [3 /*break*/, 3];
                        throw new netmd_shared_objects_1.NetMDNotImplemented('Not implemented');
                    case 3:
                        if (!(status === netmd_shared_objects_1.Status.rejected)) return [3 /*break*/, 4];
                        throw new netmd_shared_objects_1.NetMDRejected("Rejected - " + __spread(new Uint8Array(data.buffer)).map(function (n) { return n.toString(16).padStart(2, '0'); }).join(''));
                    case 4:
                        if (!(status === netmd_shared_objects_1.Status.interim && !acceptInterim)) return [3 /*break*/, 6];
                        return [4 /*yield*/, utils_1.sleep(NetMDFactoryInterface.interimResponseRetryIntervalInMs * (Math.pow(2, currentAttempt) - 1))];
                    case 5:
                        _a.sent();
                        currentAttempt += 1;
                        return [3 /*break*/, 1]; // Retry
                    case 6:
                        if ([netmd_shared_objects_1.Status.accepted, netmd_shared_objects_1.Status.implemented, netmd_shared_objects_1.Status.interim].indexOf(status) < -1) {
                            throw new netmd_shared_objects_1.NetMDNotImplemented("Unknown return status: " + status);
                        }
                        else {
                            return [3 /*break*/, 8]; // Success!
                        }
                        _a.label = 7;
                    case 7: return [3 /*break*/, 1];
                    case 8:
                        if (currentAttempt >= NetMDFactoryInterface.maxInterimReadAttempts) {
                            throw new netmd_shared_objects_1.NetMDRejected('Max attempts read attempts for interim status reached');
                        }
                        return [2 /*return*/, data.buffer.slice(1)];
                }
            });
        });
    };
    NetMDFactoryInterface.prototype.auth = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sendQuery(query_utils_1.formatQuery('1801 ff0e 4e6574204d442057616c6b6d616e'))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    NetMDFactoryInterface.prototype.changeMemoryState = function (address, length, type, state, encrypted) {
        if (encrypted === void 0) { encrypted = false; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sendQuery(query_utils_1.formatQuery('1820 ff %b %<d %b %b %b', type, address, length, state, encrypted ? 0x1 : 0x0))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    NetMDFactoryInterface.prototype.read = function (address, length, type) {
        return __awaiter(this, void 0, void 0, function () {
            var reply, res, arr;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (type !== MemoryType.MAPPED && address + 8 > 0x400)
                            throw new Error('SANITY CHECK');
                        return [4 /*yield*/, this.sendQuery(query_utils_1.formatQuery('1821 ff %b %<d %b', type, address, length))];
                    case 1:
                        reply = _a.sent();
                        res = query_utils_1.scanQuery(reply, '1821 00 %? %?%?%?%? %? %?%? %*');
                        arr = __spread(res[0]);
                        arr.splice(arr.length - 2);
                        return [2 /*return*/, new Uint8Array(arr)];
                }
            });
        });
    };
    NetMDFactoryInterface.prototype.write = function (address, data, type) {
        return __awaiter(this, void 0, void 0, function () {
            var query;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (type !== MemoryType.MAPPED && address + 8 > 0x400)
                            throw new Error('SANITY CHECK');
                        query = query_utils_1.formatQuery('1822 ff %b %<d %b 0000 %* %<w', type, address, data.length, data, calculateChecksum(data, false));
                        return [4 /*yield*/, this.sendQuery(query)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    NetMDFactoryInterface.prototype.readMetadataPeripheral = function (sector, offset, length) {
        return __awaiter(this, void 0, void 0, function () {
            var query, reply, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = query_utils_1.formatQuery('1824 ff %<w %<w %b 00', sector, offset, length);
                        return [4 /*yield*/, this.sendQuery(query)];
                    case 1:
                        reply = _a.sent();
                        res = query_utils_1.scanQuery(reply, '1824 00 %?%?%?%? %z');
                        return [2 /*return*/, res[0]];
                }
            });
        });
    };
    NetMDFactoryInterface.prototype.writeMetadataPeripheral = function (sector, offset, data) {
        return __awaiter(this, void 0, void 0, function () {
            var query;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = query_utils_1.formatQuery('1825 ff %<w %<w %z', sector, offset, data);
                        return [4 /*yield*/, this.sendQuery(query)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    NetMDFactoryInterface.prototype.setDisplayMode = function (mode) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sendQuery(query_utils_1.formatQuery('1851 ff %b', mode))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    NetMDFactoryInterface.prototype.setDisplayOverride = function (text, blink) {
        return __awaiter(this, void 0, void 0, function () {
            var fullArray, inJIS, query;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (text instanceof Uint8Array) {
                            utils_1.assert(text.length < 10, 'The Uint8Array provided has to be at most 9 bytes long');
                            fullArray = utils_1.concatUint8Arrays(text, new Uint8Array(Array(10 - text.length).fill(0)));
                        }
                        else {
                            utils_1.assert(text.length < 9, 'The text provided has to be at most 8 characters long'); // 0-terminator is required
                            inJIS = utils_1.encodeToSJIS(text);
                            fullArray = utils_1.concatUint8Arrays(inJIS, new Uint8Array(Array(10 - inJIS.length).fill(0)));
                        }
                        query = query_utils_1.formatQuery('1852 ff %b %b 00 %*', 0 /* Buffer index. Currently unknown. */, blink ? 0x1 : 0x0, fullArray);
                        return [4 /*yield*/, this.sendQuery(query)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    NetMDFactoryInterface.prototype.getDeviceVersion = function () {
        return __awaiter(this, void 0, void 0, function () {
            var query, reply, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = query_utils_1.formatQuery('1813 ff');
                        return [4 /*yield*/, this.sendQuery(query)];
                    case 1:
                        reply = _a.sent();
                        result = query_utils_1.scanQuery(reply, '1813 00 00 %B');
                        return [2 /*return*/, jsbi_1.default.toNumber(result[0])];
                }
            });
        });
    };
    NetMDFactoryInterface.prototype.getDeviceCode = function () {
        return __awaiter(this, void 0, void 0, function () {
            var query, reply, result, chipType, version;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = query_utils_1.formatQuery('1812 ff');
                        return [4 /*yield*/, this.sendQuery(query)];
                    case 1:
                        reply = _a.sent();
                        result = query_utils_1.scanQuery(reply, '1812 00 %b %b 00 %B');
                        chipType = jsbi_1.default.toNumber(result[0]);
                        version = result[2];
                        return [2 /*return*/, [chipType, version]];
                }
            });
        });
    };
    NetMDFactoryInterface.prototype.getSwitchStatus = function () {
        return __awaiter(this, void 0, void 0, function () {
            var query, reply, result, _a, internalMicroswich, button, xy, unlabeled;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        query = query_utils_1.formatQuery('1853 ff');
                        return [4 /*yield*/, this.sendQuery(query)];
                    case 1:
                        reply = _b.sent();
                        result = query_utils_1.scanQuery(reply, '1853 ff %w %b %b %w');
                        _a = __read(result, 4), internalMicroswich = _a[0], button = _a[1], xy = _a[2], unlabeled = _a[3];
                        return [2 /*return*/, [
                                jsbi_1.default.toNumber(internalMicroswich),
                                jsbi_1.default.toNumber(button),
                                jsbi_1.default.toNumber(xy),
                                jsbi_1.default.toNumber(unlabeled),
                            ]];
                }
            });
        });
    };
    NetMDFactoryInterface.interimResponseRetryIntervalInMs = 100;
    NetMDFactoryInterface.maxInterimReadAttempts = 4;
    return NetMDFactoryInterface;
}());
exports.NetMDFactoryInterface = NetMDFactoryInterface;
//# sourceMappingURL=netmd-factory-interface.js.map